import { https } from 'shared/utils/https';
import type {
  ICreateDownloadReportDTO,
  IGetDownloadReportListParamsDTO,
  IGetDownloadReportListResponseDTO,
} from './downloads.dto';

const downloadsApiVersion = 'v1';

const baseURL = `${downloadsApiVersion}/file-exports` as const;

export const downloadsData = {
  getDownloadReportListByReportType: async (
    params: IGetDownloadReportListParamsDTO,
  ): Promise<IGetDownloadReportListResponseDTO> => {
    const url = baseURL;

    const { data } = await https.get<IGetDownloadReportListResponseDTO>(url, {
      params,
    });

    return data;
  },
  createDownloadReport: async (params: ICreateDownloadReportDTO): Promise<number> => {
    const url = baseURL;

    const { data } = await https.post<number>(url, params);

    return data;
  },
};
